module.exports = __webpack_public_path__ + "assets/ArbelosDetailed.093a23d70228f605f7c0ca566b82fcac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/ArbelosDetailed.png
// module id = 470
// module chunks = 0